import type { CSSProperties } from 'react'
import {
  normalizeHexColor,
  pickContrastTextOnBackground,
} from '@/lib/campaign-winner-page-theme'
import {
  RASPADINHA_DEFAULT_PRIMARY_COLOR,
  RASPADINHA_DEFAULT_SECONDARY_COLOR,
} from '@/lib/raspadinha-campaigns/default-media-examples'
import type { RaspadinhaPublicCampaign } from '@/types/raspadinha-public-campaign'

export function buildRaspadinhaPublicPageStyleVars(
  campaign: RaspadinhaPublicCampaign
): CSSProperties {
  const primary =
    normalizeHexColor(campaign.primary_color) ?? RASPADINHA_DEFAULT_PRIMARY_COLOR
  const secondary =
    normalizeHexColor(campaign.secondary_color) ?? RASPADINHA_DEFAULT_SECONDARY_COLOR
  const onPrimary = pickContrastTextOnBackground(primary)

  return {
    '--raspadinha-primary': primary,
    '--raspadinha-secondary': secondary,
    '--raspadinha-on-primary': onPrimary,
    '--raspadinha-surface': secondary,
    '--raspadinha-text': '#f8fafc',
    '--raspadinha-text-muted': 'rgba(248, 250, 252, 0.78)',
    '--raspadinha-link': primary,
  } as CSSProperties
}
